/*!

 =========================================================
 * Vue Paper Dashboard - v2.0.0
 =========================================================

 * Product Page: http://www.creative-tim.com/product/paper-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App";
import router from "./router/index";

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";

import firebase from 'firebase/app'
import 'firebase/auth'

Vue.config.productionTip = false

const firebaseConfig = {
    apiKey: "AIzaSyBIgv2trmLrTxLu0EIG-qfacAI5RsBABUY",
    authDomain: "redashview-precena.firebaseapp.com",
    databaseURL: "https://redashview-precena.firebaseio.com",
    projectId: "redashview-precena",
    storageBucket: "redashview-precena.appspot.com",
    messagingSenderId: "92619023379",
    appId: "1:92619023379:web:315f79a5e2d23477a58be6"
};

firebase.initializeApp(firebaseConfig);

Vue.use(PaperDashboard);

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
